angular.module('impactx').service('TranslationService', ["$q", TranslationService]);

function TranslationService($q) {

    var self = this;
    var initialized = false;
    var initializedPromise = $q.defer();
    var currentLanguage = "";
    var defaultLanguage = "";
    var translations = new Map();
    var datePickerTranslations = {};

    self.reset = function (dataGen) {
        initialized = false;
        translations = new Map();
        self.getInitialTranslations(dataGen, defaultLanguage)
    };

    self.initialize = function (dataGen) {
        if (!initialized) {
            return dataGen.getData({}, {}, "/translation/list").then(function (data) {
                if (data && data.data) {
                    angular.forEach(data.data.translations, function (value, key) {
                        self.add(key, value);
                    });
                    initializeDatePickerTranslations();
                    initialized = true;
                    initializedPromise.resolve();
                }
            });
        }
        return $q.when();
    };

    self.initializeWithLanguage = function (dataGen, language) {
        return dataGen.getData({}, {"language": language}, "/translation/list/language").then(function (data) {
            if (data && data.data) {
                angular.forEach(data.data.translations, function (value, key) {
                    self.add(key, value);
                });
                initializeDatePickerTranslations();
                initialized = true;
                initializedPromise.resolve();
            }
        });
    };

    self.refresh = function (dataGen) {
        initialized = false;
        self.initialize(dataGen);
    };

    self.get = function (translationKey) {
        return translations.get(translationKey);
    };

    self.getAll = function() {
        var result = {};

        translations.forEach(function(value, key){
            if(typeof key === 'string' || typeof key === 'number') {
                result[key]= value;
            }
        });
        return result;
    }

    self.add = function (translationKey, value) {
        translations.set(translationKey, value);
    };

    self.addMany = function(trans) {

        if(trans && typeof trans === 'object') {
            for(var key in trans) {
                this.add(key, trans[key]);
            }
        }
    }

    self.getDatePickerTranslations = function () {
        if (initialized) {
            return datePickerTranslations;
        }
    };

    self.getInitialTranslations = function (dataGen, language, defaultBackendLanguage) {
        currentLanguage = language;
        if (defaultBackendLanguage) {
            defaultLanguage = defaultBackendLanguage;
        }
        return dataGen.getData({}, {countryCode: language}, '/translation/initialTranslations', null, true).then(function (data) {
            if (data) {
                angular.forEach(data.entries, function (value, key) {
                    self.add(key, value);
                });
            }
        });
    };

    self.isInitialized = function () {
        return initializedPromise.promise.$$state.status == 1;
    };

    self.onInitialization = function () {
        return initializedPromise.promise;
    };

    /**
     * This only holds the user's language selection on the login panel.
     * Not the actual language of the user's system.
     * @returns {string}
     */
    self.getCurrentLanguage = function () {
        return currentLanguage;
    };

    function initializeDatePickerTranslations() {
        datePickerTranslations = {};
        datePickerTranslations['Today'] = translations.get("today");
        datePickerTranslations['Yesterday'] = translations.get("yesterday");
        datePickerTranslations['This Week'] = translations.get("thisWeek");
        datePickerTranslations['Last Week'] = translations.get("lastWeek");
        datePickerTranslations['This Month'] = translations.get("thisMonth");
        datePickerTranslations['Last Month'] = translations.get("lastMonth");
        datePickerTranslations['This Year'] = translations.get("thisYear");
        datePickerTranslations['Last Year'] = translations.get("lastYear");
        datePickerTranslations['last30Days'] = translations.get("last30Days");
        datePickerTranslations['last90Days'] = translations.get("last90Days");
        datePickerTranslations['Custom Date Range'] = translations.get("dateRange");
        datePickerTranslations['Date Range Template'] = translations.get("dateRange");
    }
}
